/* Smooth scroll implementation that works in the following scenarios:
 *
 * 1. when someone clicks an anchor link
 * 2. if we want to scroll to a part of the page on a sprig refresh
 * 3. if there is an anchor in the url on a new page load
 *
*/
const smoothScroll = (selector, pushState = true) => {
  try {
    // Handle both ID selectors and raw element IDs
    const targetId = selector.startsWith('#') ? selector.substring(1) : selector;
    const element = document.getElementById(targetId);
    
    if (element) {
      // Get the element's position
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset;
      
      // Define offset (height of your menu) - adjust this value as needed
      const offset = 80; // Adjust this value based on your menu height
      
      // Perform the smooth scroll with offset
      window.scrollTo({
        top: offsetPosition - offset,
        behavior: 'smooth'
      });
      
      // Update URL if needed and not already matching
      if (pushState && window.location.hash !== `#${targetId}`) {
        history.pushState(null, '', `#${targetId}`);
      }
    }
  } catch (error) {
    console.error('Smooth scroll error:', error);
  }
};

// Make function globally available for Sprig
window.smoothScroll = smoothScroll;


// Ensure the DOM is fully loaded before attaching event listeners
document.addEventListener('DOMContentLoaded', () => {
  // Handle anchor clicks
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (link && link.getAttribute('href') !== '#') {
      e.preventDefault();
      smoothScroll(link.getAttribute('href'));
    }
  });
  
  // Handle initial page load with hash
  if (window.location.hash) {
    // Use both DOMContentLoaded and window.onload for better reliability
    // Small delay to ensure DOM is fully loaded
    setTimeout(() => {
      smoothScroll(window.location.hash, false);
    }, 100);
  }
  
  // Handle browser back/forward navigation
  window.addEventListener('hashchange', () => {
    if (window.location.hash) {
      smoothScroll(window.location.hash, false);
    }
  });
});

// Additional handler for window.onload to catch cases where images and other resources affect layout
window.addEventListener('load', () => {
  if (window.location.hash) {
    // Give a short delay to ensure everything is fully rendered
    setTimeout(() => {
      smoothScroll(window.location.hash, false);
    }, 200);
  }
});